'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base,
    OpenerRuntime,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

Base = require('./base');

OpenerRuntime = function (_Base) {
  _inherits(OpenerRuntime, _Base);

  function OpenerRuntime(definition) {
    _classCallCheck(this, OpenerRuntime);

    var _this = _possibleConstructorReturn(this, (OpenerRuntime.__proto__ || Object.getPrototypeOf(OpenerRuntime)).call(this, definition));

    _this.onMessage = _this.onMessage.bind(_this);
    _this.connecting = false;
    _this.connected = false;
    _this.buffer = [];
    return _this;
  }

  _createClass(OpenerRuntime, [{
    key: 'getElement',
    value: function getElement() {
      return null;
    }
  }, {
    key: 'isConnected',
    value: function isConnected() {
      return this.connected;
    }
  }, {
    key: 'setParentElement',
    value: function setParentElement(parent) {}
  }, {
    key: 'connect',
    value: function connect() {
      var _this2 = this;

      var timeout;
      // Let the UI know we're connecting
      this.connecting = true;
      this.emit('status', {
        online: false,
        label: 'connecting'
      });
      // Start listening for messages from the iframe
      window.addEventListener('message', this.onMessage, false);
      this.once('capabilities', function () {
        // Runtime responded with a capabilities message. We're live!
        _this2.connecting = false;
        _this2.connected = true;
        _this2.emit('status', {
          online: true,
          label: 'connected'
        });
        _this2.emit('connected');
        return _this2.flush();
      });
      // Request capabilities from opener
      this.postMessage('runtime', 'getruntime', {});
      return timeout = setTimeout(function () {
        // Keep trying until runtime responds
        return _this2.postMessage('runtime', 'getruntime', {});
      }, 500);
    }
  }, {
    key: 'updateIframe',
    value: function updateIframe() {}
  }, {
    key: 'disconnect',
    value: function disconnect() {
      this.connected = false;
      // Stop listening to messages
      window.removeEventListener('message', this.onMessage, false);
      this.emit('status', {
        online: false,
        label: 'disconnected'
      });
      return this.emit('disconnected');
    }
  }, {
    key: 'send',
    value: function send(protocol, command, payload) {
      if (this.connecting) {
        this.buffer.push({
          protocol: protocol,
          command: command,
          payload: payload
        });
        return;
      }
      return this.postMessage(protocol, command, payload);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(protocol, command, payload) {
      if (!window.opener) {
        return;
      }
      return window.opener.postMessage(JSON.stringify({
        protocol: protocol,
        command: command,
        payload: payload
      }), '*');
    }
  }, {
    key: 'onMessage',
    value: function onMessage(message) {
      var data;
      boundMethodCheck(this, OpenerRuntime);
      if (message.source && message.source !== this.iframe.contentWindow) {
        return;
      }
      // Message from unrelated source
      if (typeof message.data === 'string') {
        data = JSON.parse(message.data);
      } else {
        data = message.data;
      }
      return this.recvMessage(data);
    }
  }, {
    key: 'flush',
    value: function flush() {
      var i, item, len, ref;
      ref = this.buffer;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        this.postMessage(item.protocol, item.command, item.payload);
      }
      return this.buffer = [];
    }
  }]);

  return OpenerRuntime;
}(Base);

module.exports = OpenerRuntime;